const Card = ({ children, title, className, CardTools, style = {} }) => {
  return (
    <div style={{
      background: "#fff",
      borderRadius: "12px",
      boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
      marginBottom: "16px",
      overflow: "hidden",
      ...style,
    }}>
      {(title || CardTools) && (
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "14px 20px",
          borderBottom: "1px solid #f0f0f0",
          background: "#fff",
        }}>
          {title && (
            <span style={{
              fontWeight: 700,
              fontSize: "0.95rem",
              color: "#212121",
              letterSpacing: "0.01em",
            }}>
              {title}
            </span>
          )}
          {CardTools && <CardTools />}
        </div>
      )}
      <div style={{ padding: "16px 20px" }}>
        {children}
      </div>
    </div>
  );
};

export default Card;
